import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-06770ddb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "list-group list-group-horizontal"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "btn btn-dark",
  href: "https://github.com/rksan/barcode-detection-api-demo",
  target: "_blank"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-github"
}), /*#__PURE__*/_createTextVNode(" github "), /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-box-arrow-up-right"
})], -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  class: "position-absolute top-50 start-50 translate-middle"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-x-circle text-danger"
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "本アプリは利用するには、カメラの使用を許可してください", -1));
const _hoisted_7 = ["href"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-search"
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-box-arrow-up-right"
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "position-absolute top-50 start-50 translate-middle opacity-50"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "visually-hidden"
}, "Loading ...")])], -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "カメラを使用できるか確認しています...", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ブラウザにカメラの利用を許可してください", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $data.permission ? _renderSlot(_ctx.$slots, "default", {
    key: 0
  }, undefined, true) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(["container-fluid text-center", $options.compTheme])
  }, [_createElementVNode("div", {
    class: _normalizeClass(["position-absolute top-0 end-0", $options.compTheme])
  }, [_createElementVNode("ul", _hoisted_1, [_createElementVNode("li", {
    class: _normalizeClass(["list-group-item", $options.compTheme])
  }, _hoisted_3, 2)])], 2), _createElementVNode("div", _hoisted_4, [$data.error ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("h1", null, [_hoisted_5, _createTextVNode(_toDisplayString(this.message), 1)]), _hoisted_6, _createElementVNode("span", null, [_createElementVNode("a", {
    class: "btn btn-primary",
    href: `https://www.google.com/search?q=%E3%82%AB%E3%83%A1%E3%83%A9+%E8%A8%B1%E5%8F%AF&oq=%E3%82%AB%E3%83%A1%E3%83%A9+%E8%A8%B1%E5%8F%AF&aqs=chrome..69i57.7261j0j7&sourceid=chrome&ie=UTF-8`,
    target: "_blank"
  }, [_hoisted_8, _createTextVNode(" カメラ 許可 "), _hoisted_9], 8, _hoisted_7)])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_hoisted_10, _hoisted_11, _hoisted_12], 64))])], 2));
}